import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  message,
  DatePicker,
  TimePicker,
  Upload,
  Spin,
  Input,
} from "antd";
import {
  CameraOutlined,
  CloseOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import AppConfigs from "../Config/AppConfig";
import { update } from "../api/Apis";
import moment from "moment";
import { Storage } from "aws-amplify";
import { Link } from "react-router-dom";
import { noWhitespaceRule } from "../utils/Utils";
import Docsample from "../Images/pdf.jpg";

class LoadDelivered extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      leadDeliveryPic: props.leadData?.leadDeliveryImage?.delivery_pic,
      leadDeliverTicketPic:
        props.leadData?.leadDeliveryImage?.delivery_ticket_pic,
      uploadPicLoading: false,
      uploadTicketPicLoading: false,
      deliveryPic: props.leadData?.leadDeliveryImage?.delivery_pic,
      deliveryTicketPic: props.leadData?.leadDeliveryImage?.delivery_ticket_pic,
    };
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState({ show: false, loading: false });
  };

  beforeUpload(file) {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "application/pdf";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      // message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  }

  handleUploadPic = async (fileData, imageType) => {
    const isJpgOrPng =
      fileData?.file?.type === "image/jpeg" ||
      fileData?.file.type === "image/png" ||
      fileData?.file.type === "application/pdf";
    if (!isJpgOrPng) {
      this.setState({
        uploadPicLoading: false,
        uploadTicketPicLoading: false,
      });
    } else {
      if (imageType === "_delivery_pic_") {
        this.setState({
          uploadPicLoading: true,
        });
      } else if (imageType === "_delivery_ticket_pic_") {
        this.setState({
          uploadTicketPicLoading: true,
        });
      }
      let file = fileData["file"]["originFileObj"];
      let leadData = this.props.leadData;
      // let fileName = leadData["id"] + "_lead_delivery_pic_" + file["name"];
      let fileName = leadData["subOrderId"] + imageType + file["name"];
      await Storage.put(fileName, file, {
        contentType: file.type,
      }).then(async (result) => {
        let deliveryImage = "";
        let deliveryTicket = "";
        if (imageType === "_delivery_pic_") {
          deliveryImage = await Storage.get(result.key);
          this.setState({
            leadDeliveryPic: result.key,
            deliveryPic: deliveryImage,
            uploadPicLoading: false,
          });
        } else if (imageType === "_delivery_ticket_pic_") {
          deliveryTicket = await Storage.get(result.key);
          this.setState({
            leadDeliverTicketPic: result.key,
            deliveryTicketPic: deliveryTicket,
            uploadTicketPicLoading: false,
          });
        }
      });
    }
  };

  updateNetWeight = (data, id) => {
    this.setState({
      dataLoadingStatus: true,
    });
    update(AppConfigs["entityNames"]["netWeight"], id, data).then((result) => {
      if (result.success) {
        this.setState({
          loading: false,
        });
      } else {
        this.setState({
          loading: false,
        });
        console.log(result.errors);
      }
    });
  };

  loadDelivered = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        const { leadDeliveryPic, leadDeliverTicketPic } = this.state;
        let deliveryImagesList = {
          delivery_ticket_pic: leadDeliverTicketPic,
          delivery_pic: leadDeliveryPic,
        };

        let data = {
          entityData: {
            deliveryDateAndTime:
              moment(values["deliveryDate"]).format("MM/DD/YYYY") +
              " " +
              moment(values["deliveryTime"]).format("hh:mm A"),
            deliveryReqDate: moment(values["deliveryDate"]).format(
              "MM/DD/YYYY"
            ),
            deliveryReqTime: moment(values["deliveryTime"]).format("hh:mm A"),
            leadDeliveryImage: deliveryImagesList,
            orderStatus: AppConfigs["DELIVERED"],
            ticketNumber: values["tNumber"],
            weight: {
              grossWeight: values.grossWeight,
              tareWeight: values.tareWeight,
              netWeight:
                parseFloat(values.grossWeight - values.tareWeight) / 2000,
            },
          },
        };
        data["entityData"]["typeofPage"] = "orderDetails";
        data["entityData"]["recordId"] = this.props.leadData["id"];
        let netData = {
          entityData: {
            netWeight:
              parseFloat(values["grossWeight"] - values["tareWeight"]) / 2000,
          },
        };
        update(
          AppConfigs["entityNames"]["leads"],
          this.props.leadData["id"],
          data
        ).then((result) => {
          if (result.success) {
            message.success("Load updated successfully!");
            this.updateNetWeight(netData, this.props.leadData["id"]);
            if (this.props.callFrom === "adminDetails") {
              this.props.hideModal();
              window.location.reload();
            } else {
              this.hideModal();
              this.props.getOrders();
            }
          } else {
            this.setState({
              loading: false,
            });
            this.props.hideModal();
            console.log(result.errors);
          }
        });
      }
    });
  };

  haandleDeleteImages = (imageType) => {
    if (imageType === "_delivery_pic_") {
      this.setState({
        deliveryPic: "",
        uploadPicLoading: false,
      });
    } else if (imageType === "_delivery_ticket_pic_") {
      this.setState({
        deliveryTicketPic: "",
        uploadTicketPicLoading: false,
      });
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { leadData } = this.props;
    const imageUrl = this.state.deliveryPic;
    const imageUrl2 = this.state.deliveryTicketPic;
    return (
      <main>
        {this.props.callFrom === "orders" ? (
          <span
            style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}
            onClick={() => {
              this.showModal();
            }}
          >
            Load Delivered
          </span>
        ) : this.props.callFrom === "adminDetails" ? (
          <></>
        ) : (
          //   <h3 style={{ color: "#fff" }}>
          //     <Button
          //       style={{
          //         background: "#0e4d90",
          //         borderColor: "#FFF",
          //         color: "#FFF",
          //       }}
          //       onClick={() => {
          //         this.showModal();
          //       }}
          //     >
          //       Load Delivered
          //     </Button>
          //   </h3>
          <>
            <span className="rate">
              {this.props.leadData["callForRate"]
                ? "Call for Rate"
                : this.props.leadData["rateValue"]
                ? "Rate: $" +
                  this.props.leadData["rateValue"] +
                  "/" +
                  this.props.leadData["rateOption"]
                : "Rate: $0"}
            </span>
            {/* <Link to="#" className="pdf">Download PDF</Link> */}
            <span
              className="pdf"
              style={{ cursor: "pointer" }}
              onClick={() => {
                this.showModal();
              }}
            >
              Load Delivered
            </span>
          </>
        )}
        <Form>
          <Modal
            visible={this.state.show}
            closable={true}
            footer={[
              <Button
                key="cancel"
                className="cancel"
                onClick={() => {
                  this.hideModal();
                }}
              >
                Cancel
              </Button>,
              <Button
                type="primary"
                key="editSubmit"
                htmlType="submit"
                loading={this.state.loading}
                onClick={this.loadDelivered}
              >
                Load Delivered
              </Button>,
            ]}
          >
            <div>
              <Row>
                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  style={{ textAlign: "right" }}
                >
                  <CloseOutlined
                    onClick={() => {
                      this.hideModal();
                    }}
                    style={{
                      float: "right",
                      cursor: "pointer",
                      fontSize: "1.4em",
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span className="label">Delivery Date</span>}
                  >
                    {getFieldDecorator("deliveryDate", {
                      rules: [
                        {
                          required: true,
                          message: "Please input delivery date",
                        },
                      ],
                      initialValue: moment(leadData?.deliveryReqDate),
                    })(
                      <DatePicker
                        format="MM/DD/YYYY"
                        // disabledDate={(current) => {
                        // return current && current < moment().subtract(1, 'days');
                        // }}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span className="label">Delivery Time</span>}
                  >
                    {getFieldDecorator("deliveryTime", {
                      rules: [
                        {
                          required: true,
                          message: "Please input delivery time",
                        },
                      ],
                      initialValue: moment(
                        leadData?.deliveryReqTime,
                        "hh:mm A"
                      ),
                    })(
                      <TimePicker
                        placeholder="Delivery Time"
                        format="hh:mm A"
                        use12Hours
                        defaultOpenValue={moment("00:00", "hh:mm A")}
                        minuteStep={15}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span className="label">Ticket Number</span>}
                  >
                    {getFieldDecorator("tNumber", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Ticket Number!",
                        },
                        noWhitespaceRule,
                      ],
                      initialValue: leadData?.ticketNumber,
                    })(<Input />)}
                  </Form.Item>
                </Col>

                <Col lg={11} md={11} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span className="label">Gross Weight</span>}
                  >
                    {getFieldDecorator("grossWeight", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Gross Weight!",
                        },
                        noWhitespaceRule,
                      ],
                      initialValue: leadData?.weight?.grossWeight,
                    })(<Input />)}
                  </Form.Item>
                </Col>

                <Col
                  lg={{ span: 11, offset: 2 }}
                  md={{ span: 11, offset: 2 }}
                  sm={24}
                  xs={24}
                >
                  <Form.Item
                    className="Formitem"
                    label={<span className="label">Tare Weight</span>}
                  >
                    {getFieldDecorator("tareWeight", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Tare Weight!",
                        },
                        noWhitespaceRule,
                      ],
                      initialValue: leadData?.weight?.tareWeight,
                    })(<Input />)}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={11} md={11} sm={24} xs={24}>
                  <Form.Item
                    label={
                      <span style={{ color: "#0E4D90" }}>Delivery Image</span>
                    }
                  >
                    {getFieldDecorator("deliveryPic", {
                      // rules: [{ required: true, message: 'Please upload delivery image' }],
                    })(
                      <Spin spinning={this.state.uploadPicLoading}>
                        {imageUrl !== "" && (
                          <Col span={18}>
                            <DeleteOutlined
                              style={{
                                color: "red",
                                fontSize: "16px",
                                float: "right",
                              }}
                              onClick={() =>
                                this.haandleDeleteImages("_delivery_pic_")
                              }
                            />
                          </Col>
                        )}
                        <Col span={24}>
                          <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            style={{
                              borderRadius: "50%",
                            }}
                            showUploadList={false}
                            beforeUpload={this.beforeUpload}
                            onChange={(e) =>
                              this.handleUploadPic(e, "_delivery_pic_")
                            }
                          >
                            {imageUrl ? (
                              <img
                                src={
                                  imageUrl && imageUrl.includes(".pdf")
                                    ? Docsample
                                    : imageUrl
                                }
                                // src={imageUrl}
                                alt="avatar"
                                style={{ width: "150px", height: "150px" }}
                              />
                            ) : (
                              <CameraOutlined
                                className="camera-icon-carrier"
                                style={{
                                  width: "150px",
                                  height: "150px",
                                  paddingTop: "70px",
                                }}
                              />
                            )}
                          </Upload>
                        </Col>
                      </Spin>
                    )}
                  </Form.Item>
                </Col>
                <Col
                  lg={{ span: 11, offset: 2 }}
                  md={{ span: 11, offset: 2 }}
                  sm={24}
                  xs={24}
                >
                  <Form.Item
                    label={
                      <span style={{ color: "#0E4D90" }}>
                        Delivery Ticket Image
                      </span>
                    }
                  >
                    {getFieldDecorator("deliveryTicketPic", {
                      // rules: [{ required: true, message: 'Please upload delivery image' }],
                    })(
                      <Spin spinning={this.state.uploadTicketPicLoading}>
                        {imageUrl2 !== "" && (
                          <Col span={18}>
                            <DeleteOutlined
                              style={{
                                color: "red",
                                fontSize: "16px",
                                float: "right",
                              }}
                              onClick={() =>
                                this.haandleDeleteImages(
                                  "_delivery_ticket_pic_"
                                )
                              }
                            />
                          </Col>
                        )}
                        <Col span={24}>
                          <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            style={{
                              borderRadius: "50%",
                            }}
                            showUploadList={false}
                            beforeUpload={this.beforeUpload}
                            onChange={(e) =>
                              this.handleUploadPic(e, "_delivery_ticket_pic_")
                            }
                          >
                            {imageUrl2 ? (
                              <img
                                src={
                                  imageUrl2 && imageUrl2.includes(".pdf")
                                    ? Docsample
                                    : imageUrl2
                                }
                                alt="avatar"
                                style={{ width: "150px", height: "150px" }}
                              />
                            ) : (
                              <CameraOutlined
                                className="camera-icon-carrier"
                                style={{
                                  width: "150px",
                                  height: "150px",
                                  paddingTop: "70px",
                                }}
                              />
                            )}
                          </Upload>
                        </Col>
                      </Spin>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Modal>
        </Form>
      </main>
    );
  }
}

export default Form.create({ name: "LoadDelivered" })(LoadDelivered);
